<div class="main-container d-flex flex-column h-100" [class.paddingLeft]="isSidebarExpanded">
    <!-- Single row: text left, buttons right -->
    <div class="d-flex justify-content-between align-items-center flex-wrap">
        <!-- Left side: heading and subtitle -->
        <div class="d-flex flex-column gap-2">
            <p class="fs-16 fw-500 mb-2 mb-sm-0">Organisation Setup</p>
            <span class="text-muted small">Add and manage provider/insurer/distributor organisations</span>
        </div>

        <!-- Right side: buttons -->
        <div class="d-flex gap-2 align-items-center">
            <div class="d-flex flex-wrap me-3">
                <div class="mt-2 fs-12">
                    Filters By : &nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="filters">
                    <button class="filter-btn all" [ngClass]="{ active: selectedFilter === 'all' }"
                        (click)="applyFilter('all')">All</button>

                    <button class="filter-btn active-filter" [ngClass]="{ active: selectedFilter === 'active' }"
                        (click)="applyFilter('active')">Active</button>

                    <button class="filter-btn inactive-filter" [ngClass]="{ active: selectedFilter === 'inactive' }"
                        (click)="applyFilter('inactive')">Deactivated</button>
                </div>
            </div>
            <!-- <div class="search-container" [class.expanded]="searchExpanded" [class.marginTop]="searchExpanded"> -->
                <!-- Search Icon (always visible when collapsed) -->
                <!-- <span class="search-icon" (click)="toggleSearch()" aria-label="Open search" *ngIf="!searchExpanded"
                    matTooltip="search" matTooltipPosition="above">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                            d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314"
                            stroke-width="2" />
                    </svg>
                </span> -->

                <!-- Smoothly revealed input wrapper -->
                <!-- <div class="search-input-wrapper">
                    <mat-form-field appearance="outline" class="search-field">
                        <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                                fill="none" stroke="#0075C9" stroke-width="1.2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
                            </svg>
                        </span>
                        <input matInput placeholder="Search" [(ngModel)]="searchQuery" (input)="onSearch()" />
                        <span (click)="toggleSearch()" class="cursor-pointer close-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                                <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.5"
                                    d="m8.464 15.535l7.072-7.07m-7.072 0l7.072 7.07" />
                            </svg>
                        </span>
                    </mat-form-field>
                </div> -->
            <!-- </div> -->
            <span class="cursor-pointer" (click)="onRefresh()" [ngClass]="{ 'rotate-animation': isRotating }"
                matTooltip="refresh" matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                    <g fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.2">
                        <path d="M6.446 10.512a5.75 5.75 0 0 0 8.429 6.468m2.679-3.492A5.75 5.75 0 0 0 9.125 7.02" />
                        <path stroke-linejoin="round" d="m3.75 12.5l2.5-2.5l2.5 2.5m6.5-1l2.5 2.5l2.5-2.5" />
                    </g>
                </svg>
            </span>

            <div class="controls" matTooltip="View mode" matTooltipPosition="above">
                <app-view-mode-toggle [currentViewMode]="viewMode" (viewModeChange)="changeViewMode($event)">
                </app-view-mode-toggle>
            </div>
            <!-- <div>{{viewMode}}</div> -->

            <div class="action-boxes">
                <div (click)="openAdminInsurer()">
                    <button class="primaryBtn">Add New Organisation</button>
                </div>
            </div>

        </div>
    </div>

    @if(viewMode==='grid'){
    <div class="custom-tab-wrapper">

    <div class="filter-bar-row d-flex justify-content-between">
            <div class="pill-tabs d-flex">
                <button *ngFor="let tab of tabs; let i = index" (click)="handleTabClick(i)"
                    [class.active]="selectedTab === i">
                    {{ tab.label }}
                    <span class="count-chip" *ngIf="tab.count !== undefined">{{ tab.count }}</span>
                </button>

            </div>

            <div class="d-flex align-items-center gap-3">
                <div class="search-container" [class.expanded]="searchExpanded" [class.marginTop]="searchExpanded">
                    <!-- Search Icon (always visible when collapsed) -->
                    <span class="search-icon" (click)="toggleSearch()" aria-label="Open search"
                        *ngIf="!searchExpanded" matTooltip="search" matTooltipPosition="above">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                                d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314"
                                stroke-width="2" />
                        </svg>
                    </span>

                    <!-- Smoothly revealed input wrapper -->
                    <div class="search-input-wrapper">
                        <mat-form-field appearance="outline" class="search-field">
                            <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                                    fill="none" stroke="#0075C9" stroke-width="1.2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
                                </svg>
                            </span>
                            <input matInput placeholder="Search" [(ngModel)]="searchQuery" (input)="onSearch()" />
                            <span (click)="toggleSearch()" class="cursor-pointer close-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                                    <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.5"
                                        d="m8.464 15.535l7.072-7.07m-7.072 0l7.072 7.07" />
                                </svg>
                            </span>
                        </mat-form-field>
                    </div>
                </div>


            </div>
        </div>


            <div class="tab-content">
            <ng-container *ngIf="selectedTab === 0">
                @if(isDataLoading){
                <div class="loader-pro">
                    <app-loader></app-loader>
                </div>
                }
                @else {
                <ng-container *ngIf="insurerorg && insurerorg.length > 0;else noAgents">
                    <div class="table-container animate-slide-up">
                        <app-admin-card *ngFor="let insurer of insurerorg" [insurer]="insurer"
                            [role]="'INSURER_ORG'"></app-admin-card>
                    </div>
                </ng-container>
                <ng-template #noAgents>
                    <div class="custom-card">
                        <app-no-data-found></app-no-data-found>
                    </div>
                </ng-template>
                }
            </ng-container>
            <ng-container *ngIf="selectedTab === 1">
                @if(isDataLoading){
                <div class="loader-pro">
                    <app-loader></app-loader>
                </div>
                }
                @else {
                <ng-container *ngIf="providerorg && providerorg.length > 0;else noAgents">
                    <div class="table-container animate-slide-down">
                        <app-admin-card *ngFor="let provider of providerorg" [insurer]="provider"
                            [role]="'PROVIDER_ORG'"></app-admin-card>
                    </div>
                </ng-container>
                <ng-template #noAgents>
                    <div class="custom-card">
                        <app-no-data-found></app-no-data-found>
                    </div>
                </ng-template>
                }
            </ng-container>
            <ng-container *ngIf="selectedTab === 2">
                @if(isDataLoading){
                <div class="loader-pro">
                    <app-loader></app-loader>
                </div>
                }
                @else {
                <ng-container *ngIf="distributororg && distributororg.length > 0;else noAgents">
                    <div class="table-container animate-slide-up">
                        <app-admin-card *ngFor="let insurer of distributororg" [insurer]="insurer"
                            [role]="'DISTRIBUTOR_ORG'"></app-admin-card>
                    </div>
                </ng-container>
                <ng-template #noAgents>
                    <div class="custom-card">
                        <app-no-data-found></app-no-data-found>
                    </div>
                </ng-template>
                }
            </ng-container>
        </div>
        </div>}


         @else if (viewMode==='list') {
    <div class="custom-tab-wrapper">
        <div class="filter-bar-row d-flex justify-content-between">
            <div class="pill-tabs d-flex">
                <button *ngFor="let tab of tabs; let i = index" (click)="handleTabClick(i)"
                    [class.active]="selectedTab === i">
                    {{ tab.label }}
                    <span class="count-chip" *ngIf="tab.count !== undefined">{{ tab.count }}</span>
                </button>

            </div>

            <div class="d-flex align-items-center gap-3">
                <div class="search-container" [class.expanded]="searchExpanded" [class.marginTop]="searchExpanded">
                    <!-- Search Icon (always visible when collapsed) -->
                    <span class="search-icon" (click)="toggleSearch()" aria-label="Open search"
                        *ngIf="!searchExpanded" matTooltip="search" matTooltipPosition="above">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                                d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314"
                                stroke-width="2" />
                        </svg>
                    </span>

                    <!-- Smoothly revealed input wrapper -->
                    <div class="search-input-wrapper">
                        <mat-form-field appearance="outline" class="search-field">
                            <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                                    fill="none" stroke="#0075C9" stroke-width="1.2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
                                </svg>
                            </span>
                            <input matInput placeholder="Search" [(ngModel)]="searchQuery" (input)="onSearch()" />
                            <span (click)="toggleSearch()" class="cursor-pointer close-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                                    <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.5"
                                        d="m8.464 15.535l7.072-7.07m-7.072 0l7.072 7.07" />
                                </svg>
                            </span>
                        </mat-form-field>
                    </div>
                </div>


            </div>
        </div>


        @if(selectedTab===0){
        @if(isDataLoading){
        <div class="loader-pro">
            <app-loader></app-loader>
        </div>
        }
        @else{
        @if(insurerorg && insurerorg.length > 0;){
        <div class="table-container-admin animate-slide-down">


            <app-app-admin-table-view [data]="insurerorg" [columnDisplayNames]="DisplayedColums"
                [TableFor]="'INSURER_ORG'" (openAdminInsurerForm)="openAdminInsurerForm($event)"
                (openAdminProile)="openAdminProfile($event)" (confirmStatusUpdateFalse)="statusupdateFalse($event)"
                (confirmStatusUpdateTrue)="statusupdateTrue($event)"></app-app-admin-table-view>

        </div>

        }
        @else {
        <div class="custom-card">
            <app-no-data-found></app-no-data-found>
        </div>
        }
        }
        }

        @if(selectedTab===1){
        @if(isDataLoading){
        <div class="loader-pro">
            <app-loader></app-loader>
        </div>
        }
        @else{
        @if(providerorg && providerorg.length > 0;){
        <div class="table-container-admin animate-slide-down">


            <app-app-admin-table-view [data]="providerorg" [columnDisplayNames]="DisplayedColums"
                [TableFor]="'PROVIDER_ORG'"  (openAdminInsurerForm)="openAdminInsurerForm($event)" (openAdminProile)="openAdminProfile($event)"
                (confirmStatusUpdateFalse)="statusupdateFalse($event)"
                (confirmStatusUpdateTrue)="statusupdateTrue($event)"></app-app-admin-table-view>

        </div>

        }
        @else {
        <div class="custom-card">
            <app-no-data-found></app-no-data-found>
        </div>
        }
        }
        }

        @if(selectedTab===2){
        @if(isDataLoading){
        <div class="loader-pro">
            <app-loader></app-loader>
        </div>
        }
        @else{
        @if(distributororg && distributororg.length > 0;){
        <div class="table-container-admin animate-slide-down">

            <app-app-admin-table-view [data]="distributororg" [columnDisplayNames]="DisplayedColums"
                [TableFor]="'DISTRIBUTOR_ORG'"   (openAdminInsurerForm)="openAdminInsurerForm($event)"  
                (confirmStatusUpdateFalse)="statusupdateFalse($event)"
                (confirmStatusUpdateTrue)="statusupdateTrue($event)"></app-app-admin-table-view>

        </div>

        }
        @else{
        <div class="custom-card">
            <app-no-data-found></app-no-data-found>
        </div>
        }
        }
        }
        
    </div>
    }



          <div class="pagination-container">
            <span class="mt-1">Pages : </span>
            <button (click)="prevPage()" [disabled]="currentPage === 1" class="pagination-btn">‹</button>

            <button *ngFor="let page of [].constructor(totalPages); let i = index" (click)="goToPage(i + 1)"
                [ngClass]="{ 'active': currentPage === i + 1 }" class="pagination-btn">
                {{ i + 1 }}
            </button>

            <button (click)="nextPage()" [disabled]="currentPage === totalPages" class="pagination-btn">›</button>
        </div>
</div>